/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/
import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from '../../../../services'

export const getAllOrganizationApplicationsByUserID = createAsyncThunk('orgApplication/getAllOrganizationApplicationsByUserID', async (params, { rejectWithValue }) => {
    try { 
        console.log('paramas',params)
        const data = await api.orgAppUser.getAllOrganizationApplicationsByUserID(params)


        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getAllOrganizationApplications = createAsyncThunk('orgApplication/getAllOrganizationApplications', async (params, { rejectWithValue }) => {
    try { 
        console.log('paramas',params)
        const data = await api.orgAppUser.getAllOrganizationApplications(params)


        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
});
export const getAllOrganizationApplicationsByOrgID = createAsyncThunk('orgApplication/getAllOrganizationApplicationsByOrgID', async (params, { rejectWithValue }) => {
    try {
        const data = await api.orgAppUser.getAllOrganizationApplicationsByOrgID(params);
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
});

export const getUserApplicationRole = createAsyncThunk('orgApplication/getUserApplicationRole', async (params, { rejectWithValue }) => {
    try { 
         const data = await api.orgAppUser.getUserApplicationRole(params)
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
});

export const getStatus = createAsyncThunk('orgApplication/getOnlineOfflineStatus', async (params, { rejectWithValue }) => {
    try { 
         const data = await api.orgAppUser.getOnlineOfflineStatus(params)
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
});
